import { required, numeric, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default {
  unitConversion: {
    unit_id: {
      required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
      numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric),
      minValue: helpers.withMessage(
        () => i18n.global.t('Please select a unit.'),
        minValue(1)
      ),
    },
    conversion_factor: {
      required: helpers.withMessage(i18n.global.t('Please enter a conversion factor.'), required),
      numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the conversion factor.'), numeric),
      minValue: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Conversion factor must be at least') +  ' ' + $params.min,
        minValue(.001)
      ),
    }
  }
};
